<template>
    <CompassTag
        class="document-tag-wrapper"
        :size="size"
        :color="information.color"
        :icon="information.icon"
    >
        <slot></slot>
    </CompassTag>
</template>
<script>
import { allStatus, deliveryStatus } from 'Dictionaries/statusColors';

export default {
    props: {
        size: {
            type: String,
            default: 'medium',
        },
        type: {
            type: String,
            required: true,
        },
        isDelivery: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        information() {
            if (this.isDelivery) {
                return {
                    color: deliveryStatus[this.type].color,
                    icon: deliveryStatus[this.type].icon,
                };
            }

            return {
                color: allStatus[this.type].color,
                icon: allStatus[this.type].icon,
            };
        },
    },
};
</script>
<style lang="scss">
.document-tag-wrapper__container {
    display: flex;
    gap: calc(var(--spacing-1) - 2px);
    left: 7px;
    position: absolute;
    top: 0;
    transform: translateY(-50%);
    z-index: 1;
}
</style>
